import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { DocumentoDettaglioMetadatoModalComponent } from '../documentoDettaglioModal/documento-dettaglio-metadato-modal.component';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { FascicoliMappingService } from 'src/app/core/services/fascicoli-mapping.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { CtxMessage } from 'src/app/common/models/ctx-message';
import { MenuActions } from 'src/app/common/configuration/menu-actions';
import { CtxBodyFascicolo } from 'src/app/common/models/ctx-body-fascicolo';

@Component({
  selector: 'main [gestione-metadati]',
  templateUrl: './gestione-metadati-fascicolo.component.html',
  host: { '[attr.id]': "'content'" }
})
export class GestioneMetadatiFascicoloComponent implements OnInit, OnDestroy {

  idFascicolo: string;
  genericFascicolo: string;
  tipoPratica: string;
  tipoFascicolo: string;
  metadatiFascicolo: any;
  documenti: any[] = [];
  ctxBodyFascicolo: CtxBodyFascicolo;
  subscriptionFascicolo: Subscription;

  constructor(
    private route: ActivatedRoute,
    private operationsService: OperationsService,
    private dialog: DialogService,
    private viewManager: ViewManagerService,
    private fascicoliMappingService: FascicoliMappingService,
    private helpersService: HelpersService
  ) {}

  ngOnInit(): void {

    this.viewManager.initializeBody();
    const parentSegments = this.route.snapshot.pathFromRoot;
    if (parentSegments.length > 2) {
      this.tipoPratica = parentSegments[1].url[1]?.path;
      this.genericFascicolo = parentSegments[1].url[2]?.path;
    }

    console.log('tipoPratica:', this.tipoPratica);
    console.log('genericFascicolo:', this.genericFascicolo);
    this.fascicoliMappingService.getAllTipiFascicolo().subscribe(() => {
      this.tipoFascicolo = this.fascicoliMappingService.getIdFromLabelFascicolo(this.genericFascicolo);

      this.helpersService.getTipiPratica().subscribe(tipi => {
        const tipoPraticaObj = tipi.find(t => t.endpoint === this.tipoPratica);
        const idTipoPratica = tipoPraticaObj ? tipoPraticaObj.id : null;

        const msg = new CtxMessage(
          MenuActions.VISUALIZZA_FASCICOLO,
          idTipoPratica,
          this.tipoFascicolo,
          this.route.snapshot.paramMap.get('idFascicolo'),
          ''
        );
        console.log('CtxMessage:', msg);
        this.viewManager.disegnaMenu(msg);
        this.subscriptionFascicolo = this.viewManager.ctxBody.subscribe(res => {
          this.ctxBodyFascicolo = res as CtxBodyFascicolo;
          this.idFascicolo = this.ctxBodyFascicolo.fascicolo.id;
          this.loadMetadati();
        });
      });
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptionFascicolo) {
      this.subscriptionFascicolo.unsubscribe();
    }
    this.viewManager.completeBody();
  }

  loadMetadati(): void {
    this.operationsService.getGestioneMetadatiFascicolo(this.idFascicolo)
      .subscribe((response: any) => {
        console.log(response)
        this.metadatiFascicolo = response.fascicolo;
        this.documenti = response.listaDocumenti || [];
      });
  }

  openDocumentoMetadata(documento: any): void {
    const ref = this.dialog.open(DocumentoDettaglioMetadatoModalComponent, {
      data: {
        style: { width: '70%', overflow: true },
        documento: documento,
        title: 'Metadati documento: ' + documento.nomeFile,
      }
    });

    ref.afterClosed.subscribe();
  }

}